import React from 'react';
import { Alert } from 'antd';

const FromNotificationAlert = ({
  title,
  fallbackText,
  onClose,
  hasData,
  ...props
}) => {
  return (
    <Alert
      banner
      closable
      type={hasData ? 'success' : 'warning'}
      showIcon={false}
      onClose={onClose}
      message={hasData ? `Уведомление: ${title}` : fallbackText}
      {...props}
    />
  );
};

export default FromNotificationAlert;
